var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('EntitySearchTable',{attrs:{"headers":_vm.tableHeaders,"entityName":"campaign","entityNamePlural":"campaigns","collection":_vm.collection,"formFields":_vm.formFields}})}
var staticRenderFns = []

export { render, staticRenderFns }